import React from 'react'
import { BottleneckMessage } from '../domain/BottleneckMessage'
import { BottleneckView } from './bottleneck-view'
import { Col, Row } from '../ui/grid'
import { Box, BoxBody, BoxHeader, BoxTitle } from '../ui/box'
import Percent from '../helper/percent'
import { TimelineSpan } from '../domain/TimelineSpan'
import Router from '../router'

interface Props {
    messages: BottleneckMessage[]
    spans: TimelineSpan[]
    params: object
    router: Router
    routes: {
        clickRoute: string
        callgraphRoute: string
        timelineRoute: string
    }
}

class Bottlenecks extends React.Component<Props> {
    public static defaultProps = {
        routes: {
            clickRoute: 'XhprofProfilerBundle.Profile.bottlenecksReport',
            callgraphRoute: 'XhprofProfilerBundle.Profile.callgraph',
            timelineRoute: 'XhprofProfilerBundle.Profile.quick',
        },
    }

    public selectBottleneck = (type: string) => {
        const { router, routes } = this.props

        router.replace(routes.clickRoute, { bottleneck: type })
    }

    public render() {
        const { routes } = this.props
        const messages = this.props.messages.sort((a, b) => b.impact - a.impact)

        if (messages.length === 0) {
            // todo - We currently do not show the 'Bottlenecks' tab at all, if there are no bottlenecks.
            //        But if we would do, there should be an empty promo here, explaining the feature or congratulating the user.
            return null
        }

        const selected = this.props.params['bottleneck'] ?? null
        const selectedBottleneck = selected ? messages.find(message => message.type === selected) : messages[0]

        if (!selectedBottleneck) {
            // todo empty promo
            return null
        }

        return (
            <Row>
                <Col width={3}>
                    <Box>
                        <BoxHeader>
                            <BoxTitle>
                                <div className="text-muted text-right tw-font-size-12">
                                    Found {messages.length} {messages.length > 1 ? 'Bottlenecks' : 'Bottleneck'}
                                </div>
                            </BoxTitle>
                        </BoxHeader>
                        <BoxBody noPadding>
                            {messages.map(message => (
                                <div
                                    key={message.type}
                                    className={message.type === selectedBottleneck.type ? 'error-item active' : 'error-item'}
                                >
                                    <a
                                        onClick={() => {
                                            this.selectBottleneck(message.type)
                                        }}
                                        style={{ display: 'block' }}
                                    >
                                        <div
                                            className="pull-right tw-tooltip tw-tooltip-dataText tw-tooltip--right"
                                            data-tooltip-text="Estimated impact on the response time."
                                        >
                                            <Percent value={message.impact} />
                                        </div>
                                        {message.label}
                                    </a>
                                </div>
                            ))}
                        </BoxBody>
                    </Box>
                </Col>
                <Col width={5}>
                    <Box>
                        <BoxBody>
                            <BottleneckView
                                message={selectedBottleneck}
                                type={selectedBottleneck.type}
                                spans={this.props.spans}
                                routes={routes}
                            />
                        </BoxBody>
                    </Box>
                </Col>
            </Row>
        )
    }
}

export default Bottlenecks
